import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
import * as moment from 'moment/moment';

@Directive({
  selector: '[humanDateFormat]'
})
export class HumanDateFormatDirective {

  @Input('humanDateFormat') dateString: string = '';
  @Input('shortened') shortened?: boolean = false;
  @Input('noDay') noDay?: boolean = false;

  private humanDateFormat: string = '';

  constructor(private el: ElementRef, private _renderer: Renderer2) {}

  ngOnChanges() {
    if (this.dateString === '')
      return;
    let date = this.dateString.split('T')[0].split('-');
    let hours = this.dateString.split('T')[1].split('.')[0].split(':');
    let days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
    let day = moment(this.dateString.split('T')[0], 'YYYY-MM-DD', 'fr', true);

    this.humanDateFormat = '';
    if (this.noDay === false)
      this.humanDateFormat += days[day.isoWeekday() - 1] + ' ';
    this.humanDateFormat += date[2] + '.' + date[1] + '.' + date[0];
    if (this.shortened === false)
      this.humanDateFormat += ' à ' + hours[0] + ':' + hours[1];
    this._renderer.setProperty(this.el.nativeElement, 'innerText', this.humanDateFormat);
    this._renderer.setProperty(this.el.nativeElement, 'value', this.humanDateFormat);
  }

}
